import { useEffect } from 'react';
import { manageSubscription } from '../services/revenueCatService';
import { useSubscriptionStore } from '../store/subscriptionStore';

export function useSubscription() {
    const {
        status,
        isLoading,
        error,
        isInitialized,
        initialize,
        fetchStatus,
        isActive,
        getActiveSubscription
    } = useSubscriptionStore();

    useEffect(() => {
        initialize();
    }, [initialize]);

    const handleManageSubscription = async () => {
        try {
            const activeSubscription = getActiveSubscription();
            if (!activeSubscription) {
                throw new Error('No active subscription found');
            }
            
            if (activeSubscription.managementUrl) {
                window.location.href = activeSubscription.managementUrl;
            } else {
                const url = await manageSubscription();
                window.location.href = url;
            }
        } catch (err) {
            console.error('[useSubscription] Error managing subscription:', err);
            throw err;
        }
    };

    return {
        isActive: isActive(),
        activeSubscription: getActiveSubscription(),
        subscriptions: status?.subscriptions ?? [],
        loading: isLoading || !isInitialized,
        error,
        refreshStatus: () => fetchStatus(true),
        manageSubscription: handleManageSubscription
    };
}
